import { render } from "./FooterSection.vue?vue&type=template&id=57e417cc&scoped=true"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import "../assets/styles/footer-navigation.css?vue&type=style&index=0&id=57e417cc&scoped=true&lang=css&external"
import "./FooterSection.vue?vue&type=style&index=1&id=57e417cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e417cc"]])

export default __exports__